import { RNImageColors } from "react-native-image-colors/lib/module/module.web";
export default {
  getColors: RNImageColors.getColors
};
